import Vue from 'vue'
import Global from "@/scripts/Global";
import FileApi from "@/scripts/api/file.api"
import SessionManager from "@/Manager/Session.manager";
import {
    serverBus
} from "@/main";
import {
    Message
} from "@/classes/Message";
// import ProgressBar from "@/scripts/ProgressBar";
import ProgressBar from "@/components/ProgressBar/ProgressBar.vue";
import KeyboardManager from '@/Manager/keyboard.manager';
import {
    CPUtils
} from '@/scripts/Utils';
import PostApi from '@/scripts/api/post.api';
import {
    Logging
} from '@/scripts/Logging';
import {
    i18n
} from '@/main'
import VueSignals from '@/scripts/VueSignals';

let files_queue = new Array()
export default {
    name: 'UploadFile',
    data() {
        return {
            uploadProgress: -1,
            currData: {
                'ff_name': '',
                'ff_id': '',
                'ff_type': '',
                'file': ''
            },
            fileMessageSuccess: '',
            fileMessageError: '',
            uploadPausedIds: [],
            uploadCanceldId: '',
            uploadFileId: '',
            uploadFileName: '',
            uploadContinueData: [],
            broken_uploads: [],
            nodeType: '',
            fileURL: '',
            message: '',
            editFileName: false,
            newFileName: '',
            confirmCheck: true,
            filesCount: 1,
            currUploadFile: 1,
            uploadDisabled: false,
            fileToChannelId: '',
            timeStarted: new Date(),
        }
    },
    mounted() {
        this.currData = this.$parent.data
        this.filesCount = this.currData.files.length
        // first file from files
        this.currData.file = this.currData.files[this.currUploadFile - 1]
        this.fileURL = window.URL.createObjectURL(this.currData.file)
        this.newFileName = this.currData.file.name

        this.broken_uploads = SessionManager.getUserBrokenUploads()

        serverBus.$on(VueSignals.EMPTY_FILE_MESSAGE_REASON_SUCCESS, (success) => {
            this.fileMessageSuccess = ''
        })

        serverBus.$on(VueSignals.UPLOAD_FILE_EDIT_NAME, (success) => {
            this.editFileName = true

        })

        serverBus.$on(VueSignals.UPLOAD_FILE_MESSAGE_ERROR, (message) => {
            this.fileMessageError = message
        })

        serverBus.$on(VueSignals.EMPTY_FILE_UPLOAD_MESSAGE_ERROR, (success) => {
            this.fileMessageError = ''
            Global.globalValue(VueSignals.UPLOAD_FILE_MESSAGE_ERROR, this.fileMessageError)
        })

        serverBus.$on(VueSignals.SET_UPLOAD_PAUSED, (upload_paused_id) => {
            if (this.uploadPausedIds.indexOf(upload_paused_id) < 0) {
                this.uploadPausedIds.push(upload_paused_id)
            }
        })

        serverBus.$on(VueSignals.SET_UPLOAD_CONTINUE, (file_id) => {
            this.uploadPausedIds.splice(this.uploadPausedIds.indexOf(file_id), 1)
            for (let i = 0; i < this.uploadContinueData.length; i++) {
                if (this.uploadContinueData[i].file_id == file_id) {
                    this.ConcurrentUpload(
                        this.uploadContinueData[i].file_id,
                        this.uploadContinueData[i].file,
                        this.uploadContinueData[i].offset,
                        this.uploadContinueData[i].chunk,
                    )
                    this.uploadContinueData.splice(i, 1)
                    break
                }
            }
        })

        serverBus.$on(VueSignals.SET_UPLOAD_CANCELD, (upload_canceld_id) => {
            this.uploadCanceldId = upload_canceld_id
            this.CancelUpload()
        })
        let img_preview = document.querySelector('.upload-preview')
        setTimeout(function() {
            if (img_preview.height < 100) {
                img_preview.outerHTML = ""
            }
        }, 100)



        FileApi.MyBrokenUploads().then(res => {
            if (res.data.result) {
                this.broken_uploads = res.data.file_uploads
                this.broken_uploads.sort(function(a, b) {
                    if (a.file_name == b.file_name &&
                        a.parent_id == b.parent_id &&
                        b.progress_size > a.progress_size) {
                        return 1
                    }
                    return -1
                })
            }
            SessionManager.setUserBrokenUploads(this.broken_uploads)
            Logging.Debug(this.broken_uploads)
        })
        KeyboardManager.disableChatMode()

        let ProgressBarClass = Vue.extend(ProgressBar)
        let vm = new ProgressBarClass({
            i18n
        }).$mount()
        let ProgressBarHTML = vm.$el
        let parentNode = document.querySelector(".chat-area").parentNode
        parentNode.insertBefore(ProgressBarHTML, document.querySelector(".chat-area"))
        Global.globalValue(VueSignals.UPLOAD_FILE_DATA, {
            "id": 'kkkkkkkkkkkkkkkkkk',
            "name": 'oooooooooooooooooo'
        })

    },
    methods: {
        upload() {
            this.timeStarted = Date.now()
            this.uploadDisabled = true
            let file = this.currData.file
            this.uploadFileName = this.newFileName
            let brokenFile = this.broken_uploads.find(currFile => {
                return currFile.file_name == file.name &&
                    currFile.parent_id == this.currData.ff_id &&
                    currFile.file_size == file.size
            })
            if (typeof brokenFile != 'undefined') {
                this.uploadFileId = brokenFile.file_id
                this.nodeType = brokenFile.node_type
                this.fileToChannelId = brokenFile.parent_id

                if (this.nodeType == 'cloud') {
                    if (!this.uploadContinueData.some(currObj => {
                            return currObj.file_id == brokenFile.file_id
                        })) {
                        this.uploadContinueData.push({
                            "file_id": brokenFile.file_id,
                            "file": file,
                            "offset": brokenFile.progress_size,
                            "chunk": brokenFile.progress_size / (4 * 1024 * 1024)
                        })
                    } else {
                        for (let i = 0; i < this.uploadContinueData.length; i++) {
                            if (this.uploadContinueData[i].file_id == brokenFile.file_id) {
                                this.uploadContinueData[i] = {
                                    "file_id": brokenFile.file_id,
                                    "file": file,
                                    "offset": brokenFile.progress_size,
                                    "chunk": brokenFile.progress_size / (4 * 1024 * 1024)
                                }
                            }
                        }
                    }
                } else if (this.nodeType == 'real') {
                    if (!this.uploadContinueData.some(currObj => {
                            return currObj.file_id == brokenFile.file_id
                        })) {
                        this.uploadContinueData.push({
                            "file_id": brokenFile.file_id,
                            "file": file,
                            "offset": brokenFile.progress_size,
                            "chunk": brokenFile.progress_size / (1024 * 1024 / 2)
                        })
                    } else {
                        for (let i = 0; i < this.uploadContinueData.length; i++) {
                            if (this.uploadContinueData[i].file_id == brokenFile.file_id) {
                                this.uploadContinueData[i] = {
                                    "file_id": brokenFile.file_id,
                                    "file": file,
                                    "offset": brokenFile.progress_size,
                                    "chunk": brokenFile.progress_size / (1024 * 1024 / 2)
                                }
                            }
                        }
                    }
                }


                let ProgressBarClass = Vue.extend(ProgressBar)
                let vm = new ProgressBarClass({
                    i18n
                }).$mount()
                let ProgressBarHTML = vm.$el
                let parentNode = document.querySelector(".chat-area").parentNode
                parentNode.insertBefore(ProgressBarHTML, document.querySelector(".chat-area"))
                Global.globalValue(VueSignals.UPLOAD_FILE_DATA, {
                    "id": this.uploadFileId,
                    "name": this.uploadFileName
                })

                for (let i = 0; i < this.uploadContinueData.length; i++) {
                    if (this.uploadContinueData[i].file_id == this.uploadFileId) {
                        this.ConcurrentUpload(
                            this.uploadContinueData[i].file_id,
                            this.uploadContinueData[i].file,
                            this.uploadContinueData[i].offset,
                            this.uploadContinueData[i].chunk,
                        )
                        break
                    }
                }

                if (this.currUploadFile == this.filesCount) {
                    Global.globalValue(VueSignals.SHOW_SMALL_MODAL, false)
                }

                if (this.filesCount > 1 && this.currUploadFile < this.filesCount) {
                    this.currUploadFile++
                    this.currData.file = this.currData.files[this.currUploadFile - 1]
                    this.newFileName = this.currData.file.name
                    this.message = ''
                }
            } else {
                // if (file.size <= Global.getMAXFileSize()) {
                    let file_name = this.newFileName
                    FileApi.initUpload(file_name.replace(/([<| |>|/|\\|\||?|*|"|'])/g, "_"), file.size, this.currData.ff_id).then(res => {
                        this.uploadDisabled = false
                        if (res.data.result) {
                            let file_id = res.data.file_id
                            files_queue.push({
                                "file_id": file_id,
                                "file_name": file_name
                            })
                            this.uploadFileId = file_id
                            this.nodeType = res.data.node_type
                            this.fileToChannelId = SessionManager.getActiveChannelId()

                            let ProgressBarClass = Vue.extend(ProgressBar)
                            let vm = new ProgressBarClass({
                                i18n
                            }).$mount()
                            let ProgressBarHTML = vm.$el
                            let parentNode = document.querySelector(".chat-area").parentNode
                            parentNode.insertBefore(ProgressBarHTML, document.querySelector(".chat-area"))
                            Global.globalValue(VueSignals.UPLOAD_FILE_DATA, {
                                "id": this.uploadFileId,
                                "name": this.uploadFileName
                            })

                            if (this.currUploadFile == this.filesCount) {
                                Global.globalValue(VueSignals.SHOW_SMALL_MODAL, false)
                            }

                            if (this.filesCount > 1 && this.currUploadFile < this.filesCount) {
                                this.currUploadFile++
                                this.currData.file = this.currData.files[this.currUploadFile - 1]
                                this.newFileName = this.currData.file.name
                                this.message = ''
                            }

                            // case the file is empty
                            if (file.size == 0) {
                                this.FinishUpload(file_id)
                            } else {
                                this.ConcurrentUpload(file_id, file)
                            }
                        } else if (res.data.reason == "no_node") {
                            this.fileMessageError = "Currently there is not online node"
                            Global.globalValue(VueSignals.UPLOAD_FILE_MESSAGE_ERROR, this.fileMessageError)
                            Global.globalValue(VueSignals.REMOVE_PROGRESS_BAR, file_id)
                            setTimeout(function() {
                                Global.globalValue(VueSignals.EMPTY_FILE_UPLOAD_MESSAGE_ERROR, true)
                            }, 4000)
                        } else if (res.data.reason == "user_cannot_access_node" || res.data.reason == "user_has_no_access") {
                            this.fileMessageError = "User does not have access to the node"
                            Global.globalValue(VueSignals.UPLOAD_FILE_MESSAGE_ERROR, this.fileMessageError)
                            Global.globalValue(VueSignals.REMOVE_PROGRESS_BAR, file_id)
                            setTimeout(function() {
                                Global.globalValue(VueSignals.EMPTY_FILE_UPLOAD_MESSAGE_ERROR, true)
                            }, 4000)
                        } else if (res.data.reason == "file_already_exists") {
                            Global.globalValue(VueSignals.UPLOAD_FILE_EDIT_NAME, true)
                            Global.globalValue(VueSignals.UPLOAD_FILE_MESSAGE_ERROR, "File already exists")
                            Global.globalValue(VueSignals.REMOVE_PROGRESS_BAR, file_id)
                            setTimeout(function() {
                                Global.globalValue(VueSignals.EMPTY_FILE_UPLOAD_MESSAGE_ERROR, true)
                            }, 4000)
                        }
                    })
                // } else {
                //     this.fileMessageError = "File size is greater than 2GB, so please instead use the client version"
                //     Global.globalValue(VueSignals.REMOVE_PROGRESS_BAR, file_id)
                //     setTimeout(function() {
                //         Global.globalValue(VueSignals.EMPTY_FILE_UPLOAD_MESSAGE_ERROR, true)
                //     }, 4000)
                // }
            }


        },
        ConcurrentUpload(file_id, file, offset, chunk) {
            this.uploadDisabled = false
            let chunkSize = 4 * 1024 * 1024
            if (this.nodeType == 'real') {
                chunkSize = (1024 * 1024) / 2
            }
            let chunks = Math.ceil(file.size / chunkSize, chunkSize)
            if (typeof chunk == 'undefined' || chunk == null) {
                chunk = 0
            }
            if (typeof offset == 'undefined' || offset == null) {
                offset = chunk * chunkSize
            }
            console.log(chunkSize)
            console.log(offset)
            let till = offset + chunkSize
            if (till > file.size) {
                let deff = file.size - offset
                till = offset + deff
                console.log("last part")
                console.log(till)
            }
            console.log("chunks " + chunks)
            console.log("chunk " + chunk)
            console.log(offset + " => " + till)

            let timeElapsed = (new Date()) - this.timeStarted; //assumng that timeStarted is a Data Object
            let uploadSpeed = offset / (timeElapsed); //upload speed in second
            this.uploadProgress = Math.ceil((chunk / chunks) * 100)
            if (this.uploadPausedIds.indexOf(file_id) < 0) {
                Global.globalValue(VueSignals.UPDATE_UPLOAD_PROGRESS, {
                    "id": file_id,
                    "progress": Math.ceil((chunk / chunks) * 100),
                    "uploaded": (offset / 1024) / 1000,
                    "remaining": Math.ceil((file.size - offset) / 1024) / 1000,
                    "min": new Date(((file.size - offset) / uploadSpeed)).getMinutes(),
                    "sec": new Date(((file.size - offset) / uploadSpeed)).getSeconds()
                })
            }
            while (chunk <= chunks) {
                if (this.uploadCanceldId == file_id) {
                    this.uploadProgress = -1
                    Global.globalValue(VueSignals.UPDATE_UPLOAD_PROGRESS, {
                        "id": file_id,
                        "progress": this.uploadProgress
                    })
                    break
                }

                if (this.uploadPausedIds.indexOf(file_id) > -1) {
                    // memorize  the file
                    if (!this.uploadContinueData.some(currObj => {
                            return currObj.file_id == file_id
                        })) {
                        this.uploadContinueData.push({
                            "file_id": file_id,
                            "file": file,
                            "offset": offset,
                            "chunk": chunk
                        })
                    } else {
                        for (let i = 0; i < this.uploadContinueData.length; i++) {
                            if (this.uploadContinueData[i].file_id == file_id) {
                                this.uploadContinueData[i] = {
                                    "file_id": file_id,
                                    "file": file,
                                    "offset": offset,
                                    "chunk": chunk
                                }
                                break
                            }
                        }
                    }
                    break
                }
                return FileApi.addChunk(file_id, file.slice(offset, till)).then(res => {
                    if (res.data.result) {
                        chunk++
                        offset = chunk * chunkSize
                        if (chunk == chunks) {
                            this.FinishUpload(file_id)
                        }
                        if (chunk < chunks) {
                            return this.ConcurrentUpload(file_id, file, offset, chunk)
                        }
                    } else if (res.data.reason == "no_data") {
                        this.fileMessageError = "You try to upload an empty file"
                        Global.globalValue(VueSignals.UPLOAD_FILE_MESSAGE_ERROR, this.fileMessageError)
                        Global.globalValue(VueSignals.REMOVE_PROGRESS_BAR, file_id)
                        setTimeout(function() {
                            Global.globalValue(VueSignals.EMPTY_FILE_UPLOAD_MESSAGE_ERROR, true)
                        }, 3000)
                    } else if (res.data.reason == "user_has_no_access") {
                        this.fileMessageError = "User does not have access to the node"
                        Global.globalValue(VueSignals.UPLOAD_FILE_MESSAGE_ERROR, this.fileMessageError)
                        Global.globalValue(VueSignals.REMOVE_PROGRESS_BAR, file_id)
                        setTimeout(function() {
                            Global.globalValue(VueSignals.EMPTY_FILE_UPLOAD_MESSAGE_ERROR, true)
                        }, 4000)
                    }
                }).catch(function(error) {
                    Global.globalValue(VueSignals.UPLOAD_FILE_MESSAGE_ERROR, "File is corrupted")
                    Global.globalValue(VueSignals.REMOVE_PROGRESS_BAR, file_id)
                })
            }
        },
        FinishUpload(file_id) {
            let message_file_id = ''
            FileApi.finishUpload(file_id).then(res => {
                if (res.data.result) {
                    message_file_id = res.data.temp_file_id
                    let file_result = files_queue.find(currObj => {
                        return currObj.file_id == message_file_id
                    }) //get from the files queue
                    let file_name = file_result.file_name

                    Global.globalValue(VueSignals.CHANNEL_CONTENT_CHANGED, file_id)
                    this.uploadProgress = 100
                    Global.globalValue(VueSignals.UPDATE_UPLOAD_PROGRESS, {
                        "id": file_id,
                        "progress": this.uploadProgress
                    })
                    this.fileMessageSuccess = "File has been uploaded"

                    if (this.confirmCheck) {
                        let EncodedMessage = this.message + ' $' + file_name.replace(/([<| |>|/|\\|\||?|*|"|'])/g, "_")
                        let oMessage = new Message()
                        message_file_id = res.data.new_file_id // for normal nodes because it has diff file_id
                        oMessage.addFiles([{
                            "id": message_file_id,
                            "name": file_name.replace(/([<| |>|/|\\|\||?|*|"|'])/g, "_"),
                        }])
                        oMessage.setOrigin(EncodedMessage)
                        PostApi.create(oMessage.origin, this.fileToChannelId, oMessage.files)
                        CPUtils.ScrollChatMessagesToEnd()
                        files_queue = files_queue.filter(currObj => {
                            return currObj.file_id != message_file_id
                        }) // remove from the files queue

                        Logging.Debug(files_queue)
                        if (this.filesCount == 1 || this.currUploadFile - 1 == this.filesCount) {
                            KeyboardManager.enableChatMode()
                        }
                    }


                    setTimeout(function() {
                        Global.globalValue(VueSignals.EMPTY_FILE_MESSAGE_REASON_SUCCESS, true)
                        if (document.getElementById("progress_bar") != null) {
                            let progressBar = document.getElementById("progress_bar")
                            if (progressBar.dataset.id == file_id) {
                                progressBar.outerHTML = ""
                            }
                        }
                    }, 3000)
                } else {
                    if (res.data.reason == "node_operation_failed") {
                        Global.globalValue(VueSignals.UPLOAD_FILE_MESSAGE_ERROR, "Node operation failed")
                    }
                    Global.globalValue(VueSignals.REMOVE_PROGRESS_BAR, file_id)
                }
            })
        },
        CancelUpload() {
            FileApi.CancelUpload(this.uploadCanceldId).then(res => {
                if (res.data.result) {
                    this.fileMessageSuccess = "File upload has been cancelled"
                    setTimeout(function() {
                        Global.globalValue(VueSignals.EMPTY_FILE_MESSAGE_REASON_SUCCESS, true)
                    }, 3000)
                }
            })
        },
    }
}
